/* template */
<template><div :class='("packet "+(template))' :style="[(bgStyle)] | transRpxStyle"><div :class='("left "+(numberDigit))'><template v-if="(couponInfo)"><span class="integer">{{valueObj.integer}}</span><span class="point" v-if="(valueObj.point)">{{valueObj.point}}</span><span class="decimal">{{valueObj.decimal}}</span><div class="desc"><div class="tip">{{ couponTip }}</div><span class="unit">{{ couponInfo.max_benefit_capacity.unit }}</span></div></template></div><div class="right"><div class="title">{{ title }}</div><div class="subtitle" v-if="(subtitle)">{{subtitle}}</div></div><mpx-button @tap="click" class="btn">{{ btnText }}</mpx-button></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mfccd8b2c"}'>
  .packet
    box-sizing: border-box;
    width 750rpx
    height 370rpx
    background-size: 100% 100%
    background-image: url('https://ut-static.udache.com/webx/ut/ol88ndPIJYriloOhI8WJL.png')
    background-repeat: no-repeat
    margin-left auto
    margin-right auto
    overflow hidden
    position relative
    display flex
    padding 56rpx 52rpx 172rpx
    &.cz
      .left
        .tip
          width: 60rpx;
          height: 28rpx;
          line-height: 28rpx;
          background: #E33C2B;
      .right
        .title
          // width: 332rpx;
          height: 56rpx;
          font-family: PingFangSC-Semibold;
          font-size: 40rpx;
          color: #B24437;
          letter-spacing: 1.46rpx;
          font-weight: 600;
        .subtitle
          // width: 332rpx;
          height: 25rpx;
          opacity: 0.48;
          font-family: PingFangSC-Medium;
          font-size: 18rpx;
          color: #B24437;
          font-weight: 500;
    .left
      flex 1
      position relative
      font-size: 100rpx;
      font-family: DIN-Bold, DIN-Bold-self;
      color: #E33C2B;
      text-shadow: 1px 1px 0px #FFF;
      line-height 1
      display: flex;
      align-items: center;
      justify-content: center;
      top -12rpx
      &.digit-3
        font-size: 100rpx;
        letter-spacing -2rpx
      .point
        margin-left -4rpx
        margin-right -10rpx
      .desc
        display flex
        flex-direction column
      .unit
        font-size: 36rpx;
        font-family: PingFang SC;
        font-weight: bold;
        color: #E33C2B;
        text-shadow: 1px 1px 0 #FFF;
        position relative
        right: -8rpx
        bottom -24rpx
      .tip
        position absolute
        right: 36rpx;
        top: 2rpx;
        letter-spacing normal
        text-shadow: none
        width: 56rpx;
        height: 25rpx;
        background: #F3B651;
        border-radius: 13rpx 13rpx 13rpx 0;
        box-shadow: 1px 1px 0 0 rgba(255, 255, 255, 0.7);
        font-size: 18rpx;
        font-family: PingFang SC;
        font-weight: 300;
        color: #FFF;
        text-align center
        line-height 28rpx
    .right
      width 400rpx
      box-sizing border-box
      flex-shrink 0
      padding 0 0 36rpx 24rpx
      padding-bottom: 36rpx;
      align-self: center;
      .title
        font-size: 43rpx;
        font-family: PingFang SC;
        font-weight: 800;
        color: #B14536;
        text-shadow: 1px 1px 0px #FFFFFF;
    .btn, .limit
      position absolute
      left 50%
      transform translate(-50%)
    .btn
      background-image: linear-gradient(180deg, #FFFDE5 0%, #FFE490 100%);
      box-shadow: 0px 10rpx 19rpx 0px rgba(131,5,5,0.48);
      border-radius: 69rpx;
      width 486rpx
      height 118rpx
      line-height 118rpx
      bottom 41rpx
      font-size: 56rpx;
      font-family: PingFang SC;
      text-shadow: 0 2rpx 0 rgba(255,255,255,0.85);
      font-weight: bold;
      color: #E33D37;
      text-align center
      margin-bottom 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mfccd8b2c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./red-packet-close.mpx.js?isComponent&outputPath=components%2Fred-packet-closefccd8b2c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./red-packet-close.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fred-packet-closefccd8b2c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mfccd8b2c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/red-packet-closefccd8b2c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'coupon-price':getComponent(require("./coupon-price.mpx?isComponent&outputPath=components%2Fcoupon-price6e4ad8c6%2Findex")),'mpx-button':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-button.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
